import React from 'react';
import Modal from '../../../components/Modal';
import {
  chipStyle,
  chipWrapStyle,
  panelSubStyle,
  rowMetaStyle,
  rowTitleStyle,
  summaryCardStyle,
  summaryGridStyle,
  summaryLabelStyle,
  summaryValueStyle,
} from './dashboardStyles';

function Summary({ label, value, help }) {
  return (
    <div style={summaryCardStyle}>
      <div style={summaryLabelStyle}>{label}</div>
      <div style={summaryValueStyle}>{value ?? '-'}</div>
      {help ? <div style={{ ...rowMetaStyle, marginTop: 4 }}>{help}</div> : null}
    </div>
  );
}

function permissionList(permissions) {
  if (!permissions?.length) return '연결 권한 없음';
  return permissions.map((permission) => permission.label || permission.code).join(', ');
}

export default function TenantModulePermissionPreviewModal({ preview, onClose }) {
  if (!preview) return null;
  const { tenant, module, summary, guidance, permissions, affectedEmployees } = preview;
  const title = `${tenant.name} / ${module.name} 권한 미리보기`;

  return (
    <Modal open={Boolean(preview)} title={title} icon="🔍" onClose={onClose} width="min(760px, calc(100vw - 32px))" mobileSheet>
      <div style={{ display: 'grid', gap: 12 }}>
        <div style={summaryCardStyle}>
          <div style={rowTitleStyle}>{guidance.headline}</div>
          <div style={{ ...panelSubStyle, whiteSpace: 'normal', marginTop: 4 }}>
            {guidance.detail}
          </div>
          <div style={{ ...rowMetaStyle, marginTop: 8 }}>
            이 미리보기는 조회 전용입니다. `user_permissions`를 추가하거나 삭제하지 않습니다.
          </div>
        </div>

        <div style={summaryGridStyle}>
          <Summary label="현재 상태" value={module.isEnabled ? '사용 중' : '꺼짐'} help="SaaS 기능 원장 기준" />
          <Summary label="연결 권한" value={`${summary.linkedPermissionCount}개`} help={permissionList(permissions)} />
          <Summary label="영향 직원" value={`${summary.affectedEmployeeCount}명`} help="현재 해당 권한을 가진 직원" />
        </div>

        <div style={summaryCardStyle}>
          <div style={rowTitleStyle}>영향 직원 상세</div>
          {!affectedEmployees?.length ? (
            <div style={{ ...rowMetaStyle, marginTop: 6 }}>현재 이 모듈 권한을 가진 직원이 없습니다.</div>
          ) : (
            <div style={{ display: 'grid', gap: 8, marginTop: 8 }}>
              {affectedEmployees.map((employee) => (
                <div
                  key={employee.id}
                  style={{
                    border: '1px solid var(--border)',
                    borderRadius: 7,
                    padding: '8px 9px',
                    background: 'var(--bg-subtle)',
                  }}
                >
                  <div style={rowTitleStyle}>{employee.name}</div>
                  <div style={rowMetaStyle}>
                    {employee.loginId} · {employee.department || '-'}
                  </div>
                  <div style={chipWrapStyle}>
                    {(employee.permissions || []).map((permission) => (
                      <span key={`${employee.id}-${permission.code}`} style={chipStyle}>
                        {permission.label}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}
